export class RegimeJuridico {
  cd: number = null;
  ds: string = null;

  constructor(d?) {
    if (d) {
      this.cd = d.cd ? d.cd : null;
      this.ds = d.ds ? d.ds : null;
    }
  }
}
